import { Anchor, PageHeading } from 'components/atoms';
import { Head, PageLayout } from 'components/molecules';
import { getTranslations } from 'i18n';
import type { GetServerSideProps, NextPage } from 'next';
import React from 'react';
import { renderContentBlock } from 'utils';
import { useTranslation } from 'utils/hooks';
import { RichTextComponent } from 'utils/hooks/useTranslation';

const AgbB2cPage: NextPage = () =>
{
  const translations = useTranslation('agb-b2c');
  const { t } = translations;

  const richComponents: Record<string, RichTextComponent> = {
    privacy: <Anchor href="/datenschutz" />,
  };

  return (
    <PageLayout textContentPage>

      <Head title={t('agb-b2c:meta.title')}>
        <meta name="description" content={t('agb-b2c:meta.description')} />
        <meta name="keywords" content={t('agb-b2c:meta.keywords')} />
      </Head>

      <PageHeading title={t('agb-b2c:heading')} />

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p>{t('agb-b2c:version')}</p>
        <Anchor href={'/agb'}>{t('agb-b2c:toB2b')}</Anchor>
      </div>

      <div className="noListStyles">
        <ol>

          {renderContentBlock('agb-b2c:content', translations, richComponents)}

        </ol>
      </div>
    </PageLayout>
  );
};

export default AgbB2cPage;

export const getServerSideProps: GetServerSideProps = async (ctx) =>
{
  const { locale } = ctx;
  const translations = await getTranslations(locale, 'agb-b2c');

  return { props: { ...translations } };
};
